import { overlay } from 'overlay-kit';
import type { ReactNode } from 'react';

import { ContextMenu } from '@/shared/components/context-menu';

export interface ShowContextMenuOptions {
  position: { x: number; y: number };
  children?: ReactNode;
  className?: string;
}

export function showContextMenu({
  position,
  children,
  className,
}: ShowContextMenuOptions): Promise<void> {
  return overlay.openAsync(({ isOpen, close, unmount }) => (
    <ContextMenu
      isOpen={isOpen}
      onClose={close}
      onUnmount={unmount}
      position={position}
      className={className}
    >
      {children}
    </ContextMenu>
  ));
}
